import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { VrCommonModule } from '../../vr-common.module';
import { VrcAutocompleteComponent } from './vrc-autocomplete.component';
import { VrcOptionModule } from '../vrc-option';

const exports = [VrcAutocompleteComponent];


@NgModule({
  declarations: [...exports],
  exports,
  imports: [
    CommonModule,
    VrCommonModule,
    FormsModule,
    VrcOptionModule,
    ReactiveFormsModule
  ]
})
export class VrcAutocompleteModule { }
